import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import ConfirmationModal from 'v2/common/ConfirmationModal/ConfirmationModal';
import RadioButton from 'v2/form/RadioButton/RadioButton';
import { User } from 'v2/models';
import * as yup from 'yup';

interface RequestAssignModalProps {
  onCancel: () => void;
  onOk: (show: boolean) => void;
  user: User;
  toggleAssignedToMe: (isAssignedToMe: boolean) => Promise<boolean>;
}

const schema = yup.object().shape({
  reqAssign: yup.string().oneOf(['yes', 'no']).required(),
});

const RequestAssignModal = ({
  user,
  onOk,
  onCancel,
  toggleAssignedToMe,
}: RequestAssignModalProps) => {
  const { register, getValues } = useForm<{ reqAssign: 'yes' | 'no' }>({
    defaultValues: {
      reqAssign: 'no',
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  return (
    <ConfirmationModal
      classes={{ header: 'bg-light' }}
      title={
        <div className="d-flex align-items-center">
          <span>Request Assignment</span>
        </div>
      }
      onOk={() => {
        const assignToMe = getValues().reqAssign === 'yes';
        if (assignToMe) {
          return toggleAssignedToMe(false).then((taken) => {
            onOk(!taken);
          });
        } else {
          return Promise.resolve().then(() => onOk(true));
        }
      }}
      onCancel={() => onCancel()}
      show={true}
      okBtnText="Submit"
    >
      <div>
        <p>
          Hi {user.first_name}, we see that you have other colleagues who are
          also using Nomad Data. Would you like to mark this request as
          something you are working on?
        </p>
        <form>
          <RadioButton
            label=""
            register={register('reqAssign', {
              required: false,
            })}
            options={[
              { label: 'No', value: 'no' },
              { label: 'Yes', value: 'yes' },
            ]}
          />
        </form>
      </div>
    </ConfirmationModal>
  );
};

export default RequestAssignModal;
